import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=3eda8e09&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=3eda8e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda8e09",
  null
  
)

export default component.exports